import slideOne from "../../assets/images/slideOne.jpg";
import slideTwo from "../../assets/images/slideTwo.jpg";
import slideThree from "../../assets/images/slideThree.jpg";
import slideFour from "../../assets/images/slideFour.png";
import slideFive from "../../assets/images/slideFive.jpg";
import control_home from "../../assets/images/control-home.jpg";
import smart_house from "../../assets/images/smart-house.jpg";

const ProductSlider = [
  {
    product_img: slideOne,
    img_name: "slideOne",
  },
  {
    product_img: slideTwo,
    img_name: "slideTwo",
  },
  {
    product_img: smart_house,
    img_name: "smart_house",
  },
  {
    product_img: slideThree,
    img_name: "slideThree",
  },
  {
    product_img: slideFour,
    img_name: "slideFour",
  },
  {
    product_img: slideFive,
    img_name: "slideFive",
  },
  {
    product_img: control_home,
    img_name: "control_home",
  },
];

export default ProductSlider;
